import { isEqual } from 'lodash';
import { makeVar, useReactiveVar } from '@apollo/client';
import { useCallback, useMemo } from 'react';
import { GqlVideosFilter } from '../apollo/generated/graphql';

export const defaultFilter: GqlVideosFilter = {
  category: '',
  query: '',
  tag: '',
};

const filterVar = makeVar<GqlVideosFilter>(defaultFilter);

export function useVideosFilter() {
  const filter = useReactiveVar(filterVar);
  const isEmptyFilter = useMemo(() => isEqual(filter, defaultFilter), [filter]);

  const setQuery = useCallback((query: string) => {
    filterVar({
      ...defaultFilter,
      query,
    });
  }, []);

  const setTag = useCallback((tag: string) => {
    filterVar({
      ...defaultFilter,
      tag,
    });
  }, []);

  const setCategory = useCallback((category: string) => {
    filterVar({
      ...defaultFilter,
      category,
    });
  }, []);

  const clearFilter = useCallback(() => {
    filterVar(defaultFilter);
  }, []);

  return {
    filter,
    setQuery,
    setTag,
    setCategory,
    clearFilter,
    isEmptyFilter,
  };
}
